<template>
  <div>
    <div id="Daftar Nasabah">
      <div class="overflow-auto">
        <div class="row">
          <div class="col-sm-10 mb-5">
            <h2>Biaya Jasa</h2>
          </div>
        </div>
        <b-table id="pengajuan-table" responsive="true" class="text-center" :items="biayaJasaItems"
          :fields="biayaJasaFields" :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
          <template v-slot:cell(bulan)="data">
            <div>{{ formatMonthYear(data.item.jatuh_tempo) }}</div>
          </template>
          <template v-slot:cell(jumlah_pengajuan)="data">
            <div>{{ data.item.jumlah_pengajuan }}</div>
          </template>
          <template v-slot:cell(total_setoran_awal)="data">
            <div>Rp.{{ new Intl.NumberFormat().format(data.item.totals) }}</div>
          </template>
          <template v-slot:cell(total_biaya_jasa)="data">
            <div>Rp.{{ new Intl.NumberFormat().format(data.item.biayas) }}</div>
          </template>
          <template v-slot:cell(status)="data">
            <div>
              <div v-if="isNotPastDue(data.item.jatuh_tempo)">
                Tagihan bulan {{ formatMonthYear(data.item.jatuh_tempo, 1) }}
              </div>
              <div v-else-if="data.item.status == 0">Belum Dibayar</div>
              <div v-else-if="data.item.status == 1">Sudah Dibayar</div>
              <div v-else-if="data.item.status == 2">Menunggu Konfirmasi</div>
              <div v-else>Tidak Diketahui</div>
            </div>
          </template>
          <template v-slot:cell(aksi)="data">
            <b-button variant="primary" @click="openDetail(data.item)" class="float-right btn-custom">
              Detail
            </b-button>
            <b-button v-if="data.item.status == 0 && isPastDue(data.item.jatuh_tempo)" variant="primary"
              @click="pembayaran(data)" class="float-right btn-custom">
              Bayar
            </b-button>
            <b-button v-else-if="data.item.status != 0" variant="primary" @click="bukti_pembayaran(data)"
              class="float-right btn-custom d-flex align-items-center" :disabled="loadingBuktiId === getTransaksiId(data.item)">
              <b-spinner v-if="loadingBuktiId === getTransaksiId(data.item)" small class="mr-2"></b-spinner>
              Bukti Pembayaran
            </b-button>
          </template>
        </b-table>
        <b-modal size="lg" v-model="showDetailPopup" hide-footer>
          <div class="d-block">
            <h3 class="text-center mb-3 mt-0">Biaya Jasa</h3>
            <div v-if="selectedDetail">
              <div class="mb-4">
                <p class="rm-mb"><strong>Bulan:</strong> {{ formatMonthYear(selectedDetail.jatuh_tempo) }}</p>
                <p class="rm-mb"><strong>Jumlah Pengajuan:</strong> {{ selectedDetail.jumlah_pengajuan }}</p>
                <p class="rm-mb"><strong>Total Setoran Awal:</strong> Rp. {{ new Intl.NumberFormat().format(selectedDetail.totals) }}</p>
                <p class="rm-mb"><strong>Total Biaya Jasa:</strong> Rp. {{ new Intl.NumberFormat().format(selectedDetail.biayas) }}</p>
                <p class="rm-mb"><strong>Status:</strong> {{ isNotPastDue(selectedDetail.jatuh_tempo) ? 'Tagihan bulan ' + formatMonthYear(selectedDetail.jatuh_tempo, 1) : getStatusText(selectedDetail.status) }}</p>
              </div>
              <h3 class="text-center mb-3">Detail Transaksi</h3>
              <b-table
                striped
                bordered
                hover
                responsive="sm"
                :items="selectedDetail.details"
                :fields="detailFields"
                small
                class="mb-3"
              >
                <template #cell(total_setoran)="data">
                  <div>Rp. {{ new Intl.NumberFormat().format(data.item.total_setoran) }}</div>
                </template>
                <template #cell(biaya_jasa)="data">
                  <div>Rp. {{ new Intl.NumberFormat().format(data.item.biaya_jasa) }}</div>
                </template>
                <!-- <template #cell(detail_pengajuan)="data">
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="redirectToDetail(data.item.pengajuan.funder_id, data.item.pengajuan.id)"
                  >
                    Lihat Detail
                  </b-button>
                </template> -->
              </b-table>
            </div>
            <div v-else>
              <p class="text-center">Tidak ada data untuk ditampilkan.</p>
            </div>
          </div>
        </b-modal>
        <b-modal size="lg" v-model="popupPembayaran" hide-footer hide-header>
          <div class="d-block text-center">
            <h3>Tagihan Biaya Jasa</h3>
            <hr>
            <h3>{{ modalText }}</h3>
            <h2>Rp.{{ new Intl.NumberFormat().format(modalBiaya) }}</h2>
            <h3>Lakukan pembayaran ke No Rekening Bank CIMB Niaga :</h3>
            <h2>860020754900</h2>
            <h3>a.n. PT Efunding Teknologi Keuangan</h3>
            <h3>Lampirkan bukti pembayaran setelahnya. Pembayaran Anda akan divalidasi oleh admin paling lambat 1x24 jam
            </h3>
          </div>
          <div class="row">
            <div class="col">
              <b-button class="mt-3 btn-custom success" block @click="confirmPembayaran = true, popupPembayaran = false">Unggah Bukti
                Pembayaran</b-button>
            </div>
            <div class="col">
              <b-button class="mt-3 btn-custom cancel" block @click="popupPembayaran = false">Tutup</b-button>
            </div>
          </div>
        </b-modal>
        <b-modal size="sm" v-model="confirmPembayaran" hide-footer hide-header>
          <div class="d-block text-center">
            <h3>Unggah Bukti Pembayaran</h3>
            <hr>
            <b-form @submit.prevent="handleSubmit(addBukti)">
              <b-form-file v-model="form_attachment.image_url" @change="imageChange" class="mt-3 mb-2" plain
                required></b-form-file>
              <div v-if="thumbnail != null">
                <b-img thumbnail fluid width="200px" height="300px" :src="thumbnail" alt="Preview"></b-img>
              </div>
            </b-form>
          </div>
          <div class="row">
            <div class="col">
              <b-button class="mt-3 btn-custom" block @click="confirmAddBukti">Unggah</b-button>
            </div>
          </div>
        </b-modal>
        <h2 v-if="loaded == false" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
        <b-pagination align="center" :total-rows="0" :per-page="perPagePengajuan" aria-controls="pengajuan-table"
          v-model="currentPagePengajuan"></b-pagination>
      </div>
    </div>
    <b-modal size="md" v-model="successUploadBukti" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Unggah Bukti Pembayaran Berhasil</h3>
        <hr>
        <h3>Pembayaran Anda akan divalidasi oleh admin paling lambat 1x24 jam</h3>
      </div>
      <b-button class="mt-3 btn-custom cancel" block @click="successUpload">Tutup</b-button>
    </b-modal>
    <b-modal size="md" v-model="showBukti" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Bukti Pembayaran</h3>
        <hr>
        <b-img thumbnail fluid width="200px" height="300px" :src="img_attach"></b-img>
      </div>
      <b-button class="mt-3 btn-custom cancel" block @click="showBukti = false">Tutup</b-button>
    </b-modal>
  </div>
</template>

<script>
import BiayaJasa from '../../api/biayajasa.js';
import BiayaJasaAttachment from '../../api/biayajasaattachment.js';

const biayaJasaFields = [
  {
    key: 'bulan',
    label: 'Bulan',
    sortable: true
  },
  {
    key: 'jumlah_pengajuan',
    label: 'Jumlah Pengajuan',
    sortable: true
  },
  {
    key: 'total_setoran_awal',
    label: 'Total Setoran Awal',
    sortable: true
  },
  {
    key: 'total_biaya_jasa',
    label: 'Total Biaya Jasa',
    sortable: true
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true
  },
  {
    key: 'aksi',
    label: 'Aksi',
  },
]

export default {
  name: "DaftarNasabah",

  data() {
    return {
      biayajasas: [],
      biayaJasaItems: [],
      biayaJasaFields: biayaJasaFields,
      perPagePengajuan: 5,
      produk_id: '',
      currentPagePengajuan: 1,
      confirmDeleteModal: false,
      loaded: false,
      confirmStatusModal: false,
      successModal: false,
      modalTitle: '',
      changingStatus: false,
      no: 1,
      popupPembayaran: false,
      modalText: '',
      modalBiaya: 0,
      confirmPembayaran: false,
      image_url: null,
      biaya_jasa_id: null,
      successUploadBukti: false,
      // form_attachment: {},
      thumbnail: null,
      img_attach: null,
      showBukti: false,
      loadingBuktiId: null,
      form_attachment: {
        id_transaksi: null,
        image_url: null,
      },
      showDetailPopup: false,
      selectedDetail: null,
      detailFields: [
        { key: 'pengajuan.funder_id', label: 'ID Nasabah' },
        { key: 'pengajuan.product.nama_produk', label: 'Nama Produk' },
        { key: 'pengajuan.product.sub_product_category.name', label: 'Sub Category' },
        { key: 'pengajuan.funder.name', label: 'Nama Nasabah' },
        { key: 'pengajuan.funder.no_telpon', label: 'No Handphone' },
        { key: 'total_setoran', label: 'Setoran Awal' },
        { key: 'biaya_jasa', label: 'Biaya Jasa' },
        { key: 'created_at', label: 'Tanggal Dibuat' },
        // { key: 'detail_pengajuan', label: 'Detail Pengajuan' },
      ],
    }
  },

  computed: {
    rowsPengajuan() {
      return this.biayaJasaItems.length;
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // redirectToDetail(funderId, pengajuanId) {
    //   const detailUrl = `/show-funder/${funderId}/${pengajuanId}`;
    //   window.location.href = detailUrl;
    // },
    formatMonthYear(jatuh_tempo, add_months = null) {
      const months = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
      ];

      const date = new Date(jatuh_tempo);
      if (isNaN(date.getTime())) return jatuh_tempo;
      
      // Mengatur tanggal ke 1 agar tidak terjadi lompatan bulan 
      date.setDate(1);

      if (add_months != null) {
        date.setMonth(date.getMonth() + add_months);
      }

      return months[date.getMonth()] + ' ' + date.getFullYear();
    },
    getTransaksiId(item) {
      if (item && item.details && item.details.length > 0) {
        return item.details[0].id_transaksi;
      }
      return item ? item.id_transaksi : null;
    },
    isNotPastDue(jatuhTempo) {
      const today = new Date();
      const dueDate = new Date(jatuhTempo);
      return dueDate > today;
    },
    isPastDue(jatuhTempo) {
      const today = new Date();
      const dueDate = new Date(jatuhTempo);
      return dueDate < today;
    },
    loadData() {
      BiayaJasa.index()
        .then(res => {
          this.biayaJasaItems = res.data.data
          this.loaded = true;
        })
        .catch(err => console.log(err))
    },
    openDetail(item) {
      this.selectedDetail = item;
      this.showDetailPopup = true;
    },
    changeStatus(item) {
      this.product_id = ''
      this.product_id = item.id
      this.modalTitle = 'Apa anda yakin?'
      this.confirmStatusModal = true;
    },

    pembayaran(item) {

      this.popupPembayaran = true;
      this.modalTitle = 'Tagihan Biaya Jasa'
      this.modalText = 'Jumlah tagihan biaya jasa anda untuk bulan ' + this.formatMonthYear(item.item.jatuh_tempo) + ' adalah:'
      this.modalBiaya = item.item.biayas
      this.biaya_jasa_id = item.item.details[0].id_transaksi
      this.form_attachment.id_transaksi = item.item.details[0].id_transaksi
    },

    bukti_pembayaran(item) {
      const idTransaksi = this.getTransaksiId(item.item);

      this.loadingBuktiId = idTransaksi;

      BiayaJasaAttachment.show(idTransaksi)
        .then(res => {
          if (res.data.data && res.data.data.length > 0) {
            this.img_attach = res.data.data[ 0 ].image_url
            this.showBukti = true
          } else {
            console.error("Data bukti pembayaran tidak ditemukan/kosong");
            // Anda bisa tambahkan alert atau aksi lain di sini jika bukti belum lengkap/tidak ada dari server
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loadingBuktiId = null;
        });
    },

    successUpload() {
      this.successUploadBukti = false
      this.loadData()
    },

    addBuktiPembayaran(item) {
      this.confirmPembayaran = true;
    },

    confirmAddBukti() {
      this.confirmPembayaran = false;
      // this.form_attachment = {
      //   id_transaksi: this.biaya_jasa_id,
      //   image_url: this.image_url
      // }
      const image = {
        image_url: this.thumbnail
      }
      this.form_attachment.image_url = image.image_url
      this.form_attachment.id_transaksi = this.biaya_jasa_id

      BiayaJasaAttachment.store(this.form_attachment)
        .then(res => {
          // console.log(res.data.meta.code)
          if (res.data.meta.code == 200) {
            this.successUploadBukti = true;
          }
        })

    },

    imageChange(e) {
      let image = e.target.files[ 0 ];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = res => {
        this.thumbnail = res.target.result
      }
    },

    confirmChangeStatus(item) {
      this.changingStatus = true;
      const data = {
        id: this.product_id
      }

      Pengajuan.changeStatus(data)
        .then(res => {
          if (res.data.meta.code == 200) {
            this.confirmStatusModal = false;
            this.changingStatus = false;
            this.successModal = true;
            this.loadData();
          } else {
            this.changingStatus = false;
          }
        })
        .catch(err => console.log(err))
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return 'Belum Dibayar';
        case 1:
          return 'Sudah Dibayar';
        case 2:
          return 'Menunggu Konfirmasi';
        default:
          return 'Status Tidak Diketahui';
      }
    },
  },

};
</script>

<style scoped>
.rm-mb {
  margin-bottom: 0;
}

.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/biaya-jasa.vue